import { payrollConfigApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { PayConfigGateway } from './PayConfigGateway';
import type {
  DeductionCodeInput,
  DeductionCodeResponse,
  EarningCodeInput,
  EarningCodeResponse,
  PayScheduleInput,
  PayScheduleResponse,
  WorkRateInput,
  WorkRateResponse,
} from './types';

export class HttpPayConfigGateway implements PayConfigGateway {
  private readonly request = createJsonClient(payrollConfigApiBaseUrl);

  listPaySchedules(signal?: AbortSignal): Promise<PayScheduleResponse[]> {
    return this.request('/api/pay-schedules', undefined, signal);
  }

  createPaySchedule(input: PayScheduleInput): Promise<PayScheduleResponse> {
    return this.request('/api/pay-schedules', { method: 'POST', body: JSON.stringify(input) });
  }

  updatePaySchedule(id: string, input: PayScheduleInput & { isActive: boolean }): Promise<PayScheduleResponse> {
    return this.request(`/api/pay-schedules/${id}`, { method: 'PUT', body: JSON.stringify(input) });
  }

  setDefaultPaySchedule(id: string): Promise<PayScheduleResponse> {
    return this.request(`/api/pay-schedules/${id}/set-default`, { method: 'POST' });
  }

  listEarningCodes(signal?: AbortSignal): Promise<EarningCodeResponse[]> {
    return this.request('/api/earning-codes', undefined, signal);
  }

  createEarningCode(input: EarningCodeInput): Promise<EarningCodeResponse> {
    return this.request('/api/earning-codes', { method: 'POST', body: JSON.stringify(input) });
  }

  updateEarningCode(id: string, input: EarningCodeInput & { isActive: boolean }): Promise<EarningCodeResponse> {
    return this.request(`/api/earning-codes/${id}`, { method: 'PUT', body: JSON.stringify(input) });
  }

  async deleteEarningCode(id: string): Promise<void> {
    await this.request(`/api/earning-codes/${id}`, { method: 'DELETE' });
  }

  listDeductionCodes(signal?: AbortSignal): Promise<DeductionCodeResponse[]> {
    return this.request('/api/deduction-codes', undefined, signal);
  }

  createDeductionCode(input: DeductionCodeInput): Promise<DeductionCodeResponse> {
    return this.request('/api/deduction-codes', { method: 'POST', body: JSON.stringify(input) });
  }

  updateDeductionCode(id: string, input: DeductionCodeInput & { isActive: boolean }): Promise<DeductionCodeResponse> {
    return this.request(`/api/deduction-codes/${id}`, { method: 'PUT', body: JSON.stringify(input) });
  }

  listWorkRates(signal?: AbortSignal): Promise<WorkRateResponse[]> {
    return this.request('/api/work-rates', undefined, signal);
  }

  createWorkRate(input: WorkRateInput): Promise<WorkRateResponse> {
    return this.request('/api/work-rates', { method: 'POST', body: JSON.stringify(input) });
  }

  async deleteDeductionCode(id: string): Promise<void> {
    await this.request(`/api/deduction-codes/${id}`, { method: 'DELETE' });
  }
}
